module.exports = __webpack_public_path__ + "assets/img/img87.5460445b.png";